var publicPath = __webpack_public_path__;
                    var symbolUrl = 'sprites.77d21cf8718091aa102ff82bd424dd62.svg#x';
                    var viewUrl = 'sprites.77d21cf8718091aa102ff82bd424dd62.svg#view-x';

                    

                    module.exports = {
                        url: publicPath + symbolUrl,
                        view: publicPath + viewUrl,
                        viewBox: '0 0 113 117',
                        title: '',
                        toString: function () {
                            return JSON.stringify(this.view);
                        }
                    };